import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export const notificationService = {
    /**
     * Fetches the count of unread notifications
     * @returns {Promise<number>}
     */
    async fetchUnreadCount() {
        const response = await axios.get(`${API_URL}/api/app/notifications/count`);
        return response.data?.data?.count || 0;
    },

    /**
     * Fetches paginated notifications from API
     * @param {number} page - Current page number (1-indexed)
     * @param {number} pageSize - Number of items per page
     * @returns {Promise<{items: Array, total: number, page: number, pageSize: number}>}
     */
    async fetchNotifications(page = 1, pageSize = 12) {
        const response = await axios.post(`${API_URL}/api/app/notifications`, {
            page,
            pageSize,
        });

        return response.data?.data || { items: [], total: 0, page: 1, pageSize: 12 };
    },

    /**
     * Marks a single notification as read
     * @param {string|number} id - Notification ID
     * @return {Promise<{ data:{ id: number, createdAt: Date, staffId: string, message: string, isRead: boolean, readAt: Date | null }}>}
     */
    async markAsRead(id) {
        await axios.patch(`${API_URL}/api/app/notifications/${id}/read`);
    },

    /**
     * Marks all unread notifications as read for a given staff
     * @return {Promise<{ data: { count: result.count } }>}
     */
    async markAllAsRead() {
        await axios.patch(`${API_URL}/api/app/notifications/read-all`);
    },

    /**
     * Marks selected notifications as read
     * @param {Array<string|number>} ids - Array of notification IDs
     * @return {Promise<{ data: { count: result.count } }>}
     */
    async markBulkAsRead(ids) {
        await axios.patch(`${API_URL}/api/app/notifications/read-bulk`, { ids });
    },
};
